import React, { useEffect, useRef, useState } from 'react';
const TYPEFORM_LIVE_ID = '01M3AHW0K9V2X1XGQPY1HBPYWN';
const TYPEFORM_SCRIPT_SRC = 'https://embed.typeform.com/next/embed.js';
type TypeformWindow = Window & {
  tf?: {
    load?: () => void;
  };
};
export function FormEmbed() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    // Remove any previous copy so the script re-scans the page for this embed on every mount.
    document.querySelectorAll(`script[src="${TYPEFORM_SCRIPT_SRC}"]`).forEach(node => node.remove());
    const script = document.createElement('script');
    script.src = TYPEFORM_SCRIPT_SRC;
    script.async = true;
    script.onload = () => {
      ;
      (window as TypeformWindow).tf?.load?.();
    };
    document.body.appendChild(script);

    // Watch for Typeform injecting its iframe so we can hide the loading state.
    const container = containerRef.current;
    const observer = new MutationObserver(() => {
      if (container?.querySelector('iframe')) {
        setLoaded(true);
        observer.disconnect();
      }
    });
    if (container) observer.observe(container, {
      childList: true,
      subtree: true
    });
    return () => {
      observer.disconnect();
      script.remove();
    };
  }, []);
  return <section className="mx-auto mt-10 max-w-2xl px-6" aria-label="Tour request form" data-id="element-18" data-mp="32umc1hmi1o3w">
      <div className="relative min-h-[520px] w-full" data-id="element-19" data-mp="3hja61jgp5prq">
        {!loaded && <div className="absolute inset-0 flex items-center justify-center border border-mist-line bg-mist" data-id="element-20" data-mp="3hld66wbkcza6">
            <span className="font-sans text-[10px] uppercase tracking-[0.35em] text-ink/60" data-id="element-21" data-mp="3cmjv1ajr1kd6">
              Loading form…
            </span>
          </div>}
        <div ref={containerRef} data-tf-live={TYPEFORM_LIVE_ID} className="relative min-h-[520px] w-full" data-id="element-22" data-mp="3miv4ztvv9y4g" />
      </div>
    </section>;
}